import React from 'react';
import styled from 'styled-components';
import SignificanceMetricType from './SignificanceMetricType';
import SignificanceMetricController from './SignificanceMetricController';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

const SignificanceMetric = () => {
  return (
    <Container>
      <SignificanceMetricType />
      <SignificanceMetricController />
    </Container>
  );
};

export default SignificanceMetric;
